import Repository from '../axios'
import { defaultPagination } from "@/constants/config";

export default {
  getLeaveSettings() {
    return Repository.get(`/admin/system_setting/leave-request-settings`)
  },
  updateLeaveSettings(payload) {
    return Repository.post(`/admin/system_setting/leave-request-settings`, payload)
  },
  getMyLeaves(year, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/staff/leaves/my-leaves?year=${year}&paginate=${pagination}&page=${pageNumber}`)
  },
  getMyLeaveStats(year) {
    return Repository.get(`/admin/staff/leaves/my-leave-stats?year=${year}`)
  },
  getLeaveRequestDetails(id) {
    return Repository.get(`/admin/staff/leaves/requests/${id}`)
  },
  requestNewLeave(payload) {
    return Repository.post('/admin/staff/leaves/requests', payload)
  },
  modifyLeaveRequest(id, payload) {
    return Repository.put(`/admin/staff/leaves/requests/${id}`, payload)
  },
  //admin operations
  getAllStaffLeaves(pageNumber = 1, filterQuery, pagination = defaultPagination, sort = '') {
    return Repository.get(`/admin/staff/leaves/requests?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  changeLeaveRequestStatus(id, status, payload) {
    return Repository.put(`/admin/staff/leaves/requests/${id}/${status}`, payload)
  },
  changeLeaveRequestCancellation(id, status, payload) {
    return Repository.post(`/admin/staff/leaves/requests/${id}/${status}`, payload)
  },
  getAdminStats(year = '2025') {
    return Repository.get(`/admin/staff/leaves/leave-analytics?year=${year}`)
  },
  //leave entitlements
  getAllStaffLeaveEntitleents(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/staff/leaves/entitlements?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getStaffLeaveEntitlementDetails(id) {
    return Repository.get(`/admin/staff/leaves/entitlements/${id}`)
  },
  modifyLeaveEntitlement(id, payload) {
    return Repository.put(`/admin/staff/leaves/entitlements/${id}`, payload)
  },
  downloadLeaveAllocationReport(filterQuery) {
    return Repository.get(`/admin/staff/leaves/entitlements/export?${filterQuery}`, {
      responseType: 'blob'
    })
  },
  getLeaveRequestLogs(id, pageNumber = 1, filterQuery, pagination = defaultPagination, checkPermission = 1) {
    return Repository.get(`/admin/log/staff/leave/${id}?paginate=${pagination}&page=${pageNumber}&check_permission=${checkPermission}`)
  }
};
